module.exports = __webpack_public_path__ + "static/media/title.272878fd.png";